module.exports = __webpack_public_path__ + "static/media/Dubrovnik_Crotia_2.ef98fb73.jpg";